<template>
  <span
    class="flag-icon"
    :class="css"
    :style="style" />
</template>

<script>
export default {
  name: 'FlagIcon',
  props: {
    code: {
      type: String,
      required: true
    },
    squared: {
      type: Boolean
    },
    rounded: {
      type: Boolean
    },
    size: {
      type: Number,
      default: 64
    }
  },
  computed: {
    css () {
      const prefix = 'flag-icon-'
      let classCss = prefix + this.code
      if (this.squared || this.rounded) classCss += ' ' + prefix + 'squared'
      if (this.rounded) classCss += ' ' + prefix + 'rounded'
      return classCss
    },
    style () {
      const addPx = n => n + 'px'
      let s = { width: addPx(this.size), height: addPx(this.size / 4 * 3) }
      if (this.squared || this.rounded) s.height = s.width
      return s
    }
  }
}
</script>

<style lang="scss">
@import "~flag-icon-css/css/flag-icon.css";
.flag-icon-rounded {
  border-radius: 50%;
}
</style>
